var map = {
	"./backgrounds/alarm-brain.svg": 8939,
	"./backgrounds/background-game.svg": 4772,
	"./backgrounds/background-gamepage-box.svg": 2714,
	"./backgrounds/background-login-header.svg": 4346,
	"./backgrounds/background-module-header.svg": 8521,
	"./backgrounds/background-swirl-grey.svg": 7840,
	"./backgrounds/background-swirl.svg": 3735,
	"./backgrounds/background.svg": 5139,
	"./backgrounds/thinking-brain.svg": 7063,
	"./buttons/button-audio-pause.svg": 2349,
	"./buttons/button-audio-play.svg": 3962,
	"./buttons/button-instructions.svg": 6751,
	"./buttons/button-login.svg": 7701,
	"./buttons/button-red-download.svg": 6400,
	"./buttons/button-red-frame.svg": 1462,
	"./buttons/button-red-medium.svg": 7455,
	"./buttons/button-red-wide.svg": 2853,
	"./buttons/button-red.svg": 4380,
	"./buttons/nav-first.svg": 8662,
	"./buttons/nav-last.svg": 7284,
	"./buttons/nav-next-skip.svg": 1509,
	"./buttons/nav-next.svg": 7899,
	"./buttons/nav-prev-skip.svg": 7168,
	"./buttons/nav-prev.svg": 1546,
	"./frames/frame-brainstorm-category.svg": 4586,
	"./frames/frame-dialogue-example-1.svg": 3094,
	"./frames/frame-dialogue-example-2.svg": 6510,
	"./frames/frame-dialogue.svg": 5693,
	"./frames/frame-game-code.svg": 3132,
	"./frames/frame-match-container.svg": 5281,
	"./frames/frame-menu-item-big-selected.svg": 4378,
	"./frames/frame-menu-item-big.svg": 4337,
	"./frames/frame-menu-item-selected.svg": 614,
	"./frames/frame-menu-item.svg": 2122,
	"./frames/frame-organize-container.svg": 9626,
	"./frames/frame-popup.svg": 9813,
	"./frames/frame-sort-category-hover.svg": 3869,
	"./frames/frame-sort-category.svg": 4278,
	"./icon-arrow-down.svg": 3395,
	"./icon-arrow-left.svg": 5604,
	"./icon-arrow-right.svg": 6058,
	"./icon-audio-progress.svg": 1185,
	"./icon-close.svg": 1924,
	"./icon-info.svg": 4141,
	"./icon-loading.svg": 7213,
	"./icon-lobby.svg": 3396,
	"./icon-logout.svg": 3347,
	"./icon-play.svg": 7371,
	"./icon-remove.svg": 1139,
	"./icon-replay.svg": 934,
	"./icon-select-answer.svg": 5769,
	"./icon-swirl.svg": 9255,
	"./icon-trash.svg": 7727,
	"./icon-video.svg": 7971,
	"./icons/alarm-brain.svg": 7312,
	"./icons/analog-teaching.svg": 9882,
	"./icons/attention.svg": 4723,
	"./icons/calm.svg": 6231,
	"./icons/communication.svg": 4532,
	"./icons/idea-round.svg": 2417,
	"./icons/making-decisions.svg": 3860,
	"./icons/online-teaching.svg": 2578,
	"./icons/plan-of-action.svg": 3818,
	"./icons/problem-solving.svg": 455,
	"./icons/thinking-brain.svg": 1763,
	"./icons/thoughts-helping.svg": 3456,
	"./icons/toolbox.svg": 1860,
	"./illustrations/eks-brugbar-tanke.svg": 5435,
	"./illustrations/eks-negativ-tanke.svg": 5081,
	"./illustrations/eksempel-1.svg": 2311,
	"./illustrations/eksempel.svg": 5996,
	"./illustrations/firkanten.svg": 1516,
	"./illustrations/langsigtet-handleplan.svg": 318,
	"./illustrations/tanketraening-1-2-3.svg": 4728,
	"./logo-cgl.png": 1103,
	"./logo-kfs.png": 9277,
	"./logo-support.png": 277,
	"./logo.svg": 2835,
	"./slides/balance-cirkel-1.svg": 7830,
	"./slides/balance-cirkel-2.svg": 14,
	"./slides/beslutninger.svg": 9689,
	"./slides/breaks.svg": 9603,
	"./slides/case-1.svg": 8349,
	"./slides/case-2.svg": 9186,
	"./slides/case-3.svg": 864,
	"./slides/case-4.svg": 3587,
	"./slides/case-5.svg": 9332,
	"./slides/case-6.svg": 445,
	"./slides/case-7.svg": 3809,
	"./slides/conflict-behaviours.svg": 6616,
	"./slides/den-daarlige-cirkel.svg": 4313,
	"./slides/eks-beslutning.svg": 9725,
	"./slides/exsample-1.svg": 5404,
	"./slides/exsample-2.svg": 6626,
	"./slides/handleplansskema.svg": 6194,
	"./slides/iderunde.svg": 2708,
	"./slides/kanin-and.svg": 1085,
	"./slides/kommunikation.svg": 5231,
	"./slides/langsigtet-maal.svg": 3969,
	"./slides/problemloesningsskema.svg": 906,
	"./slides/quotes.svg": 7318,
	"./slides/stroop-1.svg": 7817,
	"./slides/stroop-2.svg": 2821,
	"./slides/tanketraening-eks-1.svg": 2769,
	"./slides/tanketraening-eks-2.svg": 1245,
	"./slides/thinking-example.svg": 6590,
	"./slides/thought-and-feeling.svg": 2356,
	"./slides/thought-trap.svg": 8066,
	"./slides/vaerktoejskasse.svg": 5775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;